// Base configuration for all environments
const config = {
  development: {
    API_BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://bi-globe.docker:1112'
  },
  production: {
    API_BASE_URL: 'https://bi.globe-groupe.com' // Empty string for relative paths in production
  },
  test: {
    API_BASE_URL: 'http://192.168.1.40:1111'
  },
  staging: {
    API_BASE_URL: 'https://bi-prp.globe-data.tech'
  }
};

// Get current environment, fallback to 'development' if not set
const env = process.env.REACT_APP_NODE_ENV || 'development';

// Export the configuration for the current environment
export const API_BASE_URL = config[env].API_BASE_URL;

// Connect's public URL as seen by the browser — used by logout to end the SSO
// session: cookie clearing must come from the browser.
export const CONNECT_UI_URL = process.env.REACT_APP_CONNECT_UI_URL || 'https://connect.globe-groupe.com';

// The app's own identity, not configuration: the same client_id in every
// environment, preview deployments included. A second copy in the env only
// created a way for it to drift from the backend's CONNECT_CLIENT_ID.
export const CONNECT_CLIENT_ID = 'insights';

// The parent app embedding BI in an iframe: target of the "Se reconnecter"
// button when the SSO session is dead (we never render a login in the iframe).
export const PARENT_APP_URL = process.env.REACT_APP_PARENT_APP_URL || 'https://cockpit.globe-groupe.com';

// Domaine du cookie legacy `authToken` (auth Basic, apps non migrées) — ne sert
// plus qu'à sa PURGE dans App.js : la suppression doit viser le domaine de la pose.
export const COOKIE_DOMAIN = process.env.REACT_APP_COOKIE_DOMAIN || '.globe-groupe.com';

export const MAPBOX_ACCESS_TOKEN = 'pk.eyJ1IjoiZ3VpbGxhdW1lcG90aWVyIiwiYSI6ImNtOWk5NGs1cjAwYnoyanM1bnF2emk1ZWsifQ.CnKe_0BHmZA9NZJi3EUduA';

// GPS Formulaires — AI teaser feature flag. Default ON; only an explicit 'false' disables it.
export const FORM_AI_TEASER = process.env.REACT_APP_FORM_AI_TEASER !== 'false';

// You can add more configuration exports here if needed
export default {
  API_BASE_URL
};
